import VentilationCalculator from '../../Roofing/VentilationCalculator/Index';

const CMSVentilationCalculator = ({}) => <VentilationCalculator />;

export default CMSVentilationCalculator;
